import {H3, H2, PNoMargin} from '@/typography';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Row, Col, Grid} from '@/grid';
import {withMarginBottomDoubleXlToXl} from '@/hocs/withSpacing';
import {withBgYellow50, withNeutral800} from '@/hocs/withColors';
import {withUppercase} from '@/hocs/withFontType';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import PictureWrapper from '@/ui/images-wrapper';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import {useTranslations} from 'next-intl';

const imgPath = '/static/images/features/applicant-tracking/';

const Yellow50Section = withBgYellow50(SectionPadding);
const RowMargined = withMarginBottomDoubleXlToXl(Row);
const H3UpperNeutral800 = withNeutral800(
  withTextLeftToCenter(withUppercase(withMarginBottomDoubleXlToXl(H3)))
);
const DivMargined = withMarginBottomDoubleXlToXl('div');

const ApplicantTrackingSection = () => {
  const t = useTranslations('features.applicantTracking');

  const CandidateEvaluationFeaturesArray = t.raw('candidateEvaluation.features');
  const CollaborationToolsFeaturesArray = t.raw('collaborationTools.features');
  const AutomationHiringFeaturesArray = t.raw('automationHiring.features');

  return (
    <Yellow50Section>
      <Container>
        <Grid fluid>
          <RowMargined center="xs" start="lg" middle="xs">
            <Col xs={12} lg={4}>
              <H2>{t('title')}</H2>
            </Col>
            <Col xs={12} lg={8}>
              <PictureWrapper
                imgPath={imgPath}
                imageUrl="applicant-tracking-system"
                imageTypeFallback="jpg"
                alt={t('imageAlt')}
              />
            </Col>
          </RowMargined>

          <DivMargined>
            <H3UpperNeutral800 className="heading-4">
              {t('candidateEvaluation.title')}
            </H3UpperNeutral800>
            <GridLayout Col={3} lgCol={2} autoRows>
              {CandidateEvaluationFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="#FFF2D4">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3UpperNeutral800 className="heading-4">
              {t('collaborationTools.title')}
            </H3UpperNeutral800>
            <GridLayout Col={3} lgCol={2} autoRows>
              {CollaborationToolsFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="#FFF2D4">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3UpperNeutral800 className="heading-4">
              {t('automationHiring.title')}
            </H3UpperNeutral800>
            <GridLayout Col={3} lgCol={2} autoRows>
              {AutomationHiringFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="#FFF2D4">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>
        </Grid>
      </Container>
    </Yellow50Section>
  );
};

export default ApplicantTrackingSection;
